import {Product as ProductType} from '@shopify/hydrogen/storefront-api-types';
import clsx from 'clsx';
import Carousel from 'nuka-carousel';
import {ReactElement, useState} from 'react';
import {ArrowRightCursiveIcon, ArrowLeftCursiveIcon} from '~/components';
import {useWindowSize} from '~/hooks';
import {ServiceItem} from '../services/ServiceItem';

export function ProductRecommendation({
  products,
}: {
  products: ProductType[];
}): ReactElement {
  const [slideIndex, setSlideIndex] = useState(0);

  const windowWidth = useWindowSize()?.width ?? 0;

  return (
    <div className="flex flex-col bg-white px-16 py-16 md:px-24">
      <div className="mb-8">
        <div className="flex justify-between">
          <div className="text-4xl text-[#4B2304]">
            You may also <span className="font-serif italic">like</span>
          </div>
          <div className="relative flex items-center justify-between gap-2">
            <button
              onClick={() =>
                setSlideIndex((prev) => prev - (windowWidth < 600 ? 1 : 4))
              }
              className={clsx(
                'flex items-center justify-center rounded-full border border-acai-900 bg-transparent p-1',
              )}
            >
              <ArrowLeftCursiveIcon stroke="#593B37" width={32} height={32} />
            </button>
            <button
              onClick={() =>
                setSlideIndex((prev) => prev + (windowWidth < 600 ? 1 : 4))
              }
              className={clsx(
                'flex items-center justify-center rounded-full border border-acai-900 bg-transparent p-1',
              )}
            >
              <ArrowRightCursiveIcon stroke="#593B37" width={32} height={32} />
            </button>
          </div>
        </div>
      </div>
      <Carousel
        autoplay={false}
        wrapAround={true}
        renderCenterLeftControls={null}
        renderCenterRightControls={null}
        renderBottomCenterControls={null}
        slideIndex={slideIndex}
        slidesToShow={windowWidth < 600 ? 1 : 4}
        slidesToScroll={windowWidth < 600 ? 1 : 4}
        cellSpacing={10}
      >
        {products?.length ?? 0 > 0 ? (
          products?.map((product) => (
            <ServiceItem
              key={product?.id}
              product={product}
              className="w-full"
            />
          ))
        ) : (
          <div className="flex w-full justify-center">Product Unavailable</div>
        )}
      </Carousel>
    </div>
  );
}
